import { useSiteContent } from "@/hooks/useSiteContent";

const steps = [
  {
    key: "meet",
    title: "Meet her story",
    body: "Read who she is, what she plays for, and what she's building next.",
  },
  {
    key: "share",
    title: "Share her story",
    body: "Pass her profile along. Visibility is how more people find her game.",
  },
  {
    key: "support",
    title: "Support her game",
    body: "Follow her, back her directly, or bring her an opportunity.",
  },
];

const HowToBack = () => {
  const { t } = useSiteContent();

  return (
    <section id="how-to-back" className="py-14 md:py-16 bg-muted/40 border-y border-border">
      <div className="container">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            {t("how.eyebrow", "Start here")}
          </span>
          <h2 className="text-3xl md:text-4xl mt-2 text-balance">
            {t("how.heading", "How to back her game")}
          </h2>
        </div>

        <ol className="grid sm:grid-cols-3 gap-4 mt-8">
          {steps.map((s, i) => (
            <li key={s.key} className="bg-card rounded-2xl p-5 shadow-card">
              <span className="font-display text-2xl text-primary">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-display text-xl mt-1">{t(`how.step${i + 1}_title`, s.title)}</h3>
              <p className="text-sm text-muted-foreground mt-2">{t(`how.step${i + 1}_body`, s.body)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowToBack;
